import React, { useState, useEffect } from "react";

// import JS files
import MuiModal from "../../mui/MuiModal";
// import Others files

const PicsModal = ({
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  disableEscapeKeyDown = true,
  data,
  // disableBackdropClick = true,
}) => {
  return (
    <>
      <MuiModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        width={width}
        isOverflow={isOverflow}
        isNotBackdropClick={isNotBackdropClick}
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <div className="grid grid-cols-2 gap-4">
          {data.treatment_request_main_insured[0].main_insured_files.map(
            (it, ind) => {
              return [
                <div className="border border-dashed rounded-lg">
                  <img src={it.attach_file} className="rounded-t-lg" />
                  <span className="bg-slate-100 text-center w-full block p-2 ounded-b-lg">
                    {it.fa_file_type}
                  </span>
                </div>,
              ];
            }
          )}
        </div>
      </MuiModal>
    </>
  );
};

export default PicsModal;
